import React from 'react';
import PropTypes from 'prop-types';

function AmPmSelector({
  usesAmPm,
  canSelectAm,
  canSelectPm,
  timeRange,
  handleSelectTimeRange,
}) {
  if (!usesAmPm) return null;
  return (
    <div className="px-2 d-flex flex-column" style={{ position: 'absolute', right: '15px' }}>
      <div className="am-pm-overlay" style={{ transform: `translate(-50%, ${timeRange === 'am' ? '0' : '100%'})` }} />
      <label
        className="am-pm"
        style={{
          cursor: (timeRange === 'am' || !canSelectAm) ? 'default' : 'pointer',
          color: timeRange === 'am' ? 'white' : 'black',
          opacity: canSelectAm ? 1 : 0.5,
        }}
        htmlFor="am"
      >
        <span>AM</span>
        <input id="am" value="am" disabled={timeRange === 'am' || !canSelectAm} name="amPm" type="radio" className="d-none" checked={timeRange === 'am'} onChange={handleSelectTimeRange} />
      </label>
      <label
        className="am-pm"
        style={{
          cursor: (timeRange === 'pm' || !canSelectPm) ? 'default' : 'pointer',
          color: timeRange === 'pm' ? 'white' : 'black',
          opacity: canSelectPm ? 1 : 0.5,
        }}
        htmlFor="pm"
      >
        <span>PM</span>
        <input id="pm" value="pm" disabled={timeRange === 'pm' || !canSelectPm} name="amPm" type="radio" className="d-none" checked={timeRange === 'pm'} onChange={handleSelectTimeRange} />
      </label>
    </div>
  );
}

AmPmSelector.propTypes = {
  usesAmPm: PropTypes.bool.isRequired,
  canSelectAm: PropTypes.bool.isRequired,
  canSelectPm: PropTypes.bool.isRequired,
  timeRange: PropTypes.string.isRequired,
  handleSelectTimeRange: PropTypes.func.isRequired,
};

export default AmPmSelector;



// WEBPACK FOOTER //
// ./components/core/DateTimePicker2/components/AmPmSelector.js